module.exports = __webpack_public_path__ + "img/gem_coin.25369095.png";